import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <RouterLink to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', cursor: 'pointer' }}>
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/tampazakahfund.appspot.com/o/tzf_logo_edited.png?alt=media&token=1f426ae0-408f-4c4d-bc80-0e713f8a89d0" 
            alt="Tampa Zakah Fund logo" 
          />
          <h1>Tampa Zakah Fund</h1>
        </RouterLink>
      </div>
      <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li>
            <RouterLink to="/" onClick={toggleMenu}>
              About Us
            </RouterLink>
          </li>
          <li>
            <ScrollLink to="applicant-form" smooth={true} duration={500} onClick={toggleMenu}>
              Applicant Form
            </ScrollLink>
          </li>
          <li>
            <RouterLink to="/zakah-calculator" onClick={toggleMenu}>
              Zakah Calculator
            </RouterLink>
          </li>
          <li>
            <ScrollLink to="donate-buttons" smooth={true} duration={500} onClick={toggleMenu}>
              Donations
            </ScrollLink>
          </li>
        </ul>
      </div>
      <div className="menu-icon" onClick={toggleMenu}>
        <div className={`bar ${isMenuOpen ? 'change' : ''}`}></div>
        <div className={`bar ${isMenuOpen ? 'change' : ''}`}></div>
        <div className={`bar ${isMenuOpen ? 'change' : ''}`}></div>
      </div>
    </nav>
  );
};

export default Navbar;
